import AOS from "aos";

function isVisible(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

AOS.init({
  once: true,
  duration: 3000,
  disable: "mobile",
});

const animations = () => {
  let header = document.querySelector(".header");
  let headerNavMobile = document.querySelector(".header__nav-mobile");
  let body = document.querySelector("body");
  let togglerMobileMenu = document.querySelector(".navbar-toggler");
  let mobileMenu = document.querySelector(".header__nav-mobile");
  let form = document.querySelector(
    ".gform_wrapper.gravity-theme .gfield textarea"
  );
  let url_string = window.location.href;
  let url = new URL(url_string);
  let anchor = url.searchParams.get("q");
  let trigger = url.searchParams.get("t");

  function scrollToTop() {
    const buttonTop = document.getElementById("scroll-top-link");
    buttonTop.addEventListener("click", function () {
      window.lenis.scrollTo(0, {duration: 1});
    });
  }

  function triggerClickAnchors(triggerElement) {
    triggerElement.click();
    mobileMenu.classList.remove("open-mobile-menu");

    body.classList.remove("disabled");
    togglerMobileMenu.classList.remove("close-menu");
  }

  function triggerClickProductAnchors(triggerElement) {
    if (triggerElement.parentElement.classList.contains("products-item_open")) {
      return false;
    }
    triggerElement.click();
  }

  function triggerScrollAnchors(scrollToHere) {
    window.lenis.scrollTo(scrollToHere - 100, { duration: 1 });
  }

  function anchorLinks() {
    let links = document.querySelectorAll('a[href^="#"]');

    links.forEach(function (el) {
      if (el.getAttribute("href") == "#") {
        el.addEventListener("click", function (e) {
          e.preventDefault();
        });
      } else {
        el.addEventListener("click", () => {
          let href = el.getAttribute("href");
          let anchor = document.querySelector(href);
          let trigger = el.getAttribute("data-target");
          let isProductTarget = el.getAttribute("data-product-id");
          let triggerElement = document.querySelector(
            "a[href='" + trigger + "']"
          );

          if (anchor && isProductTarget) {
            triggerScrollAnchors(anchor.offsetTop);
            triggerClickProductAnchors(anchor);
          }

          if (anchor) {
            if (el.hasAttribute("data-tab-link-id") && window.innerWidth > 768)
              return;
            triggerScrollAnchors(anchor.offsetTop);
            mobileMenu.classList.remove("open-mobile-menu");

            body.classList.remove("disabled");
            togglerMobileMenu.classList.remove("close-menu");
          }

          if (triggerElement && anchor) {
            triggerScrollAnchors(anchor.offsetTop);
            triggerClickAnchors(triggerElement);
          }

          if (
            anchor === null &&
            triggerElement === null &&
            el.closest(".header_inner")
          ) {
            let anchor = el.getAttribute("href").substring(1);
            let target = el.getAttribute("data-target");
            let scrollTo = document.querySelector("#" + anchor);

            if (scrollTo) {
              triggerScrollAnchors(scrollTo.offsetTop);
            } else {
              if (target) {
                window.location.replace(
                  themeVars.home + "?q=" + anchor + "&t=" + target.substring(1)
                );
              } else {
                window.location.replace(themeVars.home + "?q=" + anchor);
              }
            }
          }
        });
      }
    });
  }

  function initAnchorHash() {
    let triggerElement = document.querySelector("a[href='#" + trigger + "']");

    if (trigger) {
      triggerClickAnchors(triggerElement);
    }

    if (anchor && triggerElement === null) {
      let scrollTo = document.querySelector("#" + anchor);
      triggerScrollAnchors(scrollTo.offsetTop);
    }
  }

  function initNativeScrollbar() {
    ["touchmove", "mousewheel", "wheel"].forEach((eventType) => {
      form && form.addEventListener(eventType, (e) => e.stopPropagation());
    });
  }

  function initStickyHeader() {
    if (typeof header != "undefined" && header != null) {
      window.lenis.on('scroll', (e) => {
        if (typeof headerNavMobile != "undefined" && headerNavMobile != null) {
          headerNavMobile.style.top = e.scroll + "px";
        }

        e.scroll > 35
          ? header.classList.add("header--scrolled")
          : header.classList.contains("header--scrolled") &&
            header.classList.remove("header--scrolled");
      });
    }
  }



  function AOSinit() {
    const elements = [...document.querySelectorAll("[data-aos]")];

    function addAnimatedClass() {
      elements.forEach((el) => {
        if (isVisible(el)) {
          el.classList.add("aos-animate");
          el.closest("footer") !== null &&
            el.closest("footer").classList.add("show");
        }
      });
    }

    addAnimatedClass();

    window.lenis.on('scroll', addAnimatedClass);
  }

  function scrollTriggerSections() {
    const sections = [...document.querySelectorAll("section")];

    sections.push(document.querySelector("footer"));

    const siteNavigationLinks = [
      ...document.querySelectorAll(".menu-item a[href^='#']"),
    ];

    if (!siteNavigationLinks.length > 0) return;

    function checkActiveItem() {
      const navList = document.getElementById("nav-main").querySelector("ul");
      const magicLine = document.getElementById("magic-line");

      if (navList.querySelector(".active")) {
        const activeLink = navList.querySelector(".active a");

        if (
          activeLink
            .closest(".menu-item.depth-0")
            .classList.contains("menu-item-has-children")
        ) {
          magicLine.style.width = `${
            activeLink.closest(".menu-item.depth-0").offsetWidth + 1
          }px`;
          magicLine.style.left = `${
            activeLink.closest(".menu-item.depth-0").offsetLeft
          }px`;
          magicLine.dataset.origLeft =
            activeLink.closest(".menu-item.depth-0").offsetLeft;
          magicLine.dataset.origWidth =
            activeLink.closest(".menu-item.depth-0").offsetWidth + 1;
        } else {
          magicLine.style.left = `${activeLink.offsetLeft}px`;
          magicLine.style.width = `${activeLink.offsetWidth + 1}px`;
          magicLine.dataset.origLeft = activeLink.offsetLeft;
          magicLine.dataset.origWidth = activeLink.offsetWidth + 1;
        }
      } else {
        magicLine.style.width = 0;
        magicLine.style.left = 0;
        magicLine.dataset.origLeft = 0;
        magicLine.dataset.origWidth = 0;
      }
    }

    function setActiveClass(section, siteNavigationLinks) {
      siteNavigationLinks.find(
        (item) =>
          item.closest("li").classList.contains("active") &&
          item.closest("li").classList.remove("active")
      );

      if (section.id) {
        siteNavigationLinks.find((link) => {
          if (link.getAttribute("href").slice(1) === section.id) {
            !link.closest("li").classList.contains("sk-btn") &&
              link.closest("li").classList.add("active");
          }
        });
      }

      checkActiveItem();
    }

    window.lenis.on('scroll', () => {
        sections.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect.top < 400 && rect.bottom > 0) {
                setActiveClass(el, siteNavigationLinks);
            }
        });
    });


    window.addEventListener("resize", () => {
      checkActiveItem();
    });
  }

  function checkNonAnchorLinks() {
    const menuLinks = [...document.querySelectorAll('.menu-item a[href^="#"]')];

    if (!themeVars.isHome) {
      menuLinks.forEach((link) => {
        link.href = themeVars.home + "#" + link.getAttribute("href").slice(1);
      });
    }
  }

  return {
    init() {
      scrollToTop();
      setTimeout(() => {
        anchorLinks();
      }, 1000);
      initNativeScrollbar();
      scrollTriggerSections();
      initStickyHeader();
      AOSinit();
      initAnchorHash();
      checkNonAnchorLinks();
    },
  };
};

export { animations };
